//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['event'],
  computed: {
    stats() {
      return _.get(this.event, 'stats')
    },
    home_scores() {
      return _.split(_.get(this.stats, 'home_scorecard'), " ")
    },
    away_scores() {
      return _.split(_.get(this.stats, 'away_scorecard'), " ")
    }
  },
  mounted() {},
  methods: {
    getOrdinal(i) {
      var j = i % 10,
          k = i % 100;
      if (j == 1 && k != 11) {
          return i + "st";
      }
      if (j == 2 && k != 12) {
          return i + "nd";
      }
      if (j == 3 && k != 13) {
          return i + "rd";
      }
      return i + "th";
    },
  }
}
